<template>
  <component v-bind:is="layout"></component>
</template>

<script>
import { gtag, pixel } from '@/helpers/marketing'
export default {
  computed: {
    layout () {
      return this.$store.state.slug
    }
  },
  methods: {
  },
  async mounted () {
    this.$store.dispatch('getEsticoInformationByToken', this.$route.params.token)
      .then(async (response) => {
        if (response.client.gtag) {
          await gtag(response.client.gtag)
        }
        if (response.client.fb_pixel) {
          await pixel(response.client.fb_pixel)
        }
      })
      .catch((error) => {
        if (error.status === 404) {
          this.$router.push({ name: 'notfound' })
        }
      })
  }
}
</script>

<style>
</style>
